import { render } from "./App.vue?vue&type=template&id=94953a6a&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=94953a6a&scoped=true&lang=scss"
import "./App.vue?vue&type=style&index=1&id=94953a6a&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94953a6a"]])

export default __exports__